// eslint-disable-next-line @treasury/filename-match-export
export default function parsePhone(s) {
    return s.replace(/\(|\)|-| /g, '').substring(0, 10);
}
